import angular from "angular";
import vis from '../../../../../lib/vis/vis.js';
import moment from "moment";

angular
    .module('ui-sentinel.devices.deviceTracking')
    .controller('DeviceTrackingSummaryController', DeviceTrackingSummaryController);

DeviceTrackingSummaryController.$inject = ['$rootScope', '$scope', '$state', '$stateParams', 'FeedbackService', 'DeviceTrackingReportsService', 'TrackingFilterService', 'DevicesService', 'ShipmentsService', 'GoogleStaticMapApiKey', 'AccountApiService', 'SentinelUiSession', 'AlarmUtilsService', 'TemperatureUtilsService'];

function DeviceTrackingSummaryController($rootScope, $scope, $state, $stateParams, FeedbackService, DeviceTrackingReportsService, TrackingFilterService, DevicesService, ShipmentsService, GoogleStaticMapApiKey, AccountApiService, SentinelUiSession, AlarmUtilsService, TemperatureUtilsService) {
    const _timelineDivId = 'summaryTimeline';
    const _reportsService = DeviceTrackingReportsService;
    const _filterService = TrackingFilterService;
    const _timeline = {
        container: document.getElementById(_timelineDivId),
        control: null,
        dataSet: new vis.DataSet({}),
        groups: [
            {
                id: 'line',
                options: {
                    drawPoints: {
                        enabled: false
                    }
                },
                className: 'print-summary-graph-line'
            },
            {
                id: 'ok',
                options: {
                    style: 'points',
                    drawPoints: {
                        size: 10,
                        enabled: true,
                        style: 'image',
                        imageUrl: '../img/print-ok-circle.png'
                    }
                }
            },
            {
                id: 'info',
                options: {
                    style: 'points',
                    drawPoints: {
                        size: 14,
                        enabled: true,
                        style: 'image',
                        imageUrl: '../img/print-info-circle.png'
                    }
                }
            },
            {
                id: 'warning',
                options: {
                    style: 'points',
                    drawPoints: {
                        enabled: true,
                        size: 14,
                        style: 'image',
                        imageUrl: '../img/print-alarm-circle.png'
                    }
                }
            }
        ],
        options: {
            width: '100%',
            height: '240px',
            orientation: 'top',
            sort: false,
            sampling: false,
            moveable: false,
            showCurrentTime: false,
            start: _reportsService.fromDate,
            end: _reportsService.toDate,
            dataAxis: {
                left: {
                    title: {
                        text: _filterService.filterByPropertyName
                    }
                }
            }
        }
    };

    const vm = {
        device: null,
        logoUrl: null,
        logoBlob: null,
        feedback: FeedbackService,
        reportName: _filterService.filterByPropertyName,
        propertyName: _filterService.range.property,
        now: moment().format('L LTS'),
        timezone: $rootScope.isOrs ? '(UTC)' : `(UTC ${moment().format('Z')})`,
        unitOfMeasure: _filterService.range.suffix,
        mean: null,
        stdDev: null,
        min: null,
        max: null,
        fromDate: null,
        toDate: null,
        staticMapUrl: null,
        reports: null,
        alarms: [],
        isOrs: $rootScope.isOrs,
        filter: filter,
        print: print,
        justify: justify,
        uniqueAlarmNames: AlarmUtilsService.uniqueAlarmNames
    };

    activate();
    return vm;

    ////////////////////////////////////////////////////////////////////////////


    function activate() {
        $rootScope.$on('CLIENT_FOCUS_CHANGED', function (event, args) {
            if ($rootScope.$state.current.name == 'device.summary') {
                $state.go('devices.map');
            }
            _reportsService.clear();
        });

        const deviceTagId = $stateParams.deviceTagId;
        loadDevice(deviceTagId);
        loadLogo(SentinelUiSession.focus);

        _timeline.control = new vis.Graph2d(_timeline.container, _timeline.dataSet, _timeline.groups, _timeline.options);

        $scope.$watchCollection(
            function () {
                return _reportsService.reports;
            },
            function (reports) {
                onReportsChange(reports);
            }
        );
        $scope.$watchCollection(
            function () {
                return _filterService;
            },
            function () {
                if ($rootScope.$state.current.name !== 'device.summary') {
                    return;
                }

                onFilterChange();
            }
        );
        $scope.$watchCollection(
            function () {
                return _filterService.range;
            },
            function () {
                if ($rootScope.$state.current.name !== 'device.summary') {
                    return;
                }

                onFilterChange();
            }
        );

        if (deviceTagId !== _reportsService.deviceTagId) {
            _reportsService.init(deviceTagId);
        }
    }

    function loadLogo(client) {
        const image = document.getElementById('print-summary-logo');

        const promise = AccountApiService.getEmailLogo(client).$promise;
        promise.then(
            function (result) {

                if (!result || !result.url) {
                    image.src = window.location.origin + '/img/DefaultEmailLogo.png';
                    return;
                }

                image.src = result.url;
            },
            function (error) {
                image.src = window.location.origin + '/img/DefaultEmailLogo.png';
            }
        );
    }

    function loadDevice(deviceTagId) {
        console.log("loadDevice", deviceTagId);
        vm.device = {
            deviceTagId: deviceTagId,
            deviceName: deviceTagId
        };
        const promise = DevicesService.getSentry(deviceTagId).$promise;
        promise.then(
            function (device) {
                console.log("loadDevice", device);
                if (device.friendlyName) {
                    vm.device.deviceName = device.friendlyName;
                }
            },
            function () {
                // device not found, ignore error
            }
        );
    }

    function justify(value) {
        if (typeof value === 'undefined' || value === null) {
            return '';
        }

        if (isNaN(value)) {
            return value;
        }

        return '' + Number(value).toFixed(2);
    }

    function onFilterChange() {
        _filterService.save();
        vm.reportName = _filterService.filterByPropertyName;
        vm.propertyName = _filterService.range.property;
        vm.unitOfMeasure = _filterService.range.suffix;
        onReportsChange(_reportsService.reports);
    }

    function onReportsChange(reports) {
        vm.reports = reports;
        vm.alarms = [];

        const polylineCoordinates = [];
        const items = [];
        const values = [];

        _.forEach(vm.reports, function (report) {
            if (report.latitude !== null && report.longitude !== null) {
                polylineCoordinates.push(new google.maps.LatLng(report.latitude, report.longitude));
            }

            const propValue = TemperatureUtilsService.getFilteredPropertyValue(report, _filterService.range.property);
            values.push(propValue);
            items.push({
                id: 'line-' + report.guid,
                x: moment(report.messageTimeStamp).local().toDate().valueOf(),
                y: propValue,
                group: 'line'
            });

            if (_filterService.filter(report)) {
                items.push({
                    id: report.severity + '-' + report.guid,
                    x: moment(report.messageTimeStamp).local().toDate().valueOf(),
                    y: propValue,
                    group: report.severity
                });
            }
        });

        vm.mean = Math.round(_.mean(values) * 100) / 100;
        vm.min = _.min(values);
        vm.max = _.max(values);

        const stdDev = [];
        _.forEach(values, function (v) {
            stdDev.push(Math.pow(v - vm.mean, 2));
        });
        vm.stdDev = Math.round(Math.sqrt(_.mean(stdDev)) * 100) / 100;

        drawMap(polylineCoordinates);
        drawTimeline(items);
    }

    function drawMap(polylineCoordinates) {
        vm.staticMapUrl = null;
        const staticMapUrl = 'https://maps.googleapis.com/maps/api/staticmap?';
        const staticMapUrlKey = '&key=' + GoogleStaticMapApiKey;

        const defaultParams = '&size=400x400&scale=2&maptype=roadmap&format=png32';

        //add the stop markers
        const stopMarkers = '';

        //add the alarm markers?
        let warnMarkers = '';
        let infoMarkers = '';
        let okMarkers = '';
        const latLngBounds = new google.maps.LatLngBounds();
        _.forEach(vm.reports, function (report, index) {
            if (!report.latitude && !report.longitude) {
                return;
            }

            latLngBounds.extend(new google.maps.LatLng(report.latitude, report.longitude));

            if (!_filterService.filter(report)) {
                return;
            }

            switch (report.severity) {
                case 'info':
                    infoMarkers += _filterService.showInfo ? '|' + report.latitude + ',' + report.longitude : '';
                    break;
                case 'warning':
                    warnMarkers += _filterService.showWarning ? '|' + report.latitude + ',' + report.longitude : '';
                    break;
                default:
                    okMarkers += _filterService.showOk ? '|' + report.latitude + ',' + report.longitude : '';
            }
        });

        let webHost = window.location.origin;
        if (webHost === 'http://localhost:3081') {
            webHost = 'http://vision.onasset.com';
        }

        if (warnMarkers.length > 0) {
            warnMarkers = '&markers=anchor:center|icon:' + webHost + '/img/print-alarm-circle.png' + warnMarkers;
        }
        if (infoMarkers.length > 0) {
            infoMarkers = '&markers=anchor:center|icon:' + webHost + '/img/print-info-circle.png' + infoMarkers;
        }
        if (okMarkers.length > 0) {
            okMarkers = '&markers=anchor:center|icon:' + webHost + '/img/print-ok-circle.png' + okMarkers;
        }

        //determine whether or not we need to specify a zoom parameter.  this will take affect if all the reports are located in a very small area
        const _MAXZOOM = 15;
        let zoomLevelParam = '';
        const zoomForBounds = getBoundsZoomLevel(latLngBounds, { height: 400, width: 400 });
        if (zoomForBounds > _MAXZOOM) {
            zoomLevelParam = '&zoom=' + _MAXZOOM;
        }

        //calculate the path
        const encodedPath = google.maps.geometry.encoding.encodePath(polylineCoordinates);
        const bgPathParam = '&path=color:0x00000099|weight:5|geodesic:false|enc:' + encodedPath;
        const fgPathParam = '&path=color:0x00ffc8cc|weight:3|geodesic:false|enc:' + encodedPath;

        let staticMapUrlTemp = staticMapUrl + encodeURI(defaultParams + zoomLevelParam + stopMarkers + warnMarkers + infoMarkers + okMarkers + bgPathParam + fgPathParam) + staticMapUrlKey;
        if (staticMapUrlTemp.length > 8192) {
            //remove okMarkers
            staticMapUrlTemp = staticMapUrl + encodeURI(defaultParams + zoomLevelParam + stopMarkers + warnMarkers + infoMarkers + bgPathParam + fgPathParam) + staticMapUrlKey;
        }
        if (staticMapUrlTemp.length > 8192) {
            //remove infoMarkers
            staticMapUrlTemp = staticMapUrl + encodeURI(defaultParams + zoomLevelParam + stopMarkers + warnMarkers + bgPathParam + fgPathParam) + staticMapUrlKey;
        }
        if (staticMapUrlTemp.length > 8192) {
            //remove warnMarkers
            staticMapUrlTemp = staticMapUrl + encodeURI(defaultParams + stopMarkers + bgPathParam + fgPathParam) + staticMapUrlKey;
        }
        vm.staticMapUrl = staticMapUrlTemp;
    }

    function getBoundsZoomLevel(bounds, mapDim) {
        //function source code from http://stackoverflow.com/questions/6048975/google-maps-v3-how-to-calculate-the-zoom-level-for-a-given-bounds
        const WORLD_DIM = { height: 256, width: 256 };
        const ZOOM_MAX = 21;

        function latRad(lat) {
            const sin = Math.sin(lat * Math.PI / 180);
            const radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
            return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
        }

        function zoom(mapPx, worldPx, fraction) {
            return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
        }

        const ne = bounds.getNorthEast();
        const sw = bounds.getSouthWest();

        const latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

        const lngDiff = ne.lng() - sw.lng();
        const lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

        const latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
        const lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);

        return Math.min(latZoom, lngZoom, ZOOM_MAX);
    }


    function drawTimeline(items) {
        _timeline.dataSet.clear();
        _timeline.dataSet.add(items);


        vm.toDate = moment(_reportsService.toDate.value).format('L LTS');//moment(lastReport.messageTimeStamp).local().format('L LTS');
        vm.fromDate = moment(_reportsService.fromDate.value).format('L LTS'); //moment(firstReport.messageTimeStamp).local().format('L LTS');

        _timeline.control.setOptions({
            dataAxis: {
                left: {
                    title: {
                        text: _filterService.filterByPropertyName
                    },
                    format: function (value) {
                        return '' + Math.round(value);
                    }
                }
            },
            groups: {
                visibility: {
                    line: true,
                    ok: _filterService.showOk,
                    info: _filterService.showInfo,
                    warning: _filterService.showWarning
                }
            }
        });
        _timeline.control.fit();
        _timeline.control.redraw();
    }

    function filter(report) {
        return _filterService.filter(report);
    }

    function print() {
        window.print();
    }
}
